import { createContext, useReducer, useContext } from 'react';
import * as R from 'ramda';

const FormalGameStateContext = createContext();
const FormalGameDispatchContext = createContext();

const initFormalGameState = {
  statsUpdateRows: {},
};

const formalGameReducer = (state, action) => {
  const { type, payload } = action;
  switch (type) {
    case 'RESET_STATS_UPDATE_ROWS': {
      return {
        ...state,
        statsUpdateRows: {},
      };
    }
    case 'SAVE_STATS_UPDATE_ROW': {
      const toUpdate = { toUpdateColumn: payload.toUpdateColumn, newValue: payload.newValue };
      if (!state.statsUpdateRows[payload.rowIndex]) {
        return {
          ...state,
          statsUpdateRows: {
            ...state.statsUpdateRows,
            [payload.rowIndex]: [toUpdate],
          },
        };
      }

      const columnIndex = R.findIndex(
        (col) => col.toUpdateColumn === toUpdate.toUpdateColumn,
        state.statsUpdateRows[payload.rowIndex],
      );
      if (columnIndex >= 0) {
        state.statsUpdateRows[payload.rowIndex][columnIndex] = toUpdate;
      } else {
        state.statsUpdateRows[payload.rowIndex].push(toUpdate);
      }

      return {
        ...state,
        statsUpdateRows: {
          ...state.statsUpdateRows,
          [payload.rowIndex]: [...state.statsUpdateRows[payload.rowIndex]],
        },
      };
    }
    case 'REMOVE_STATS_UPDATE_ROW': {
      state.statsUpdateRows[payload.rowIndex].splice(payload.columnIndex, 1);
      if (state.statsUpdateRows[payload.rowIndex].length === 0) {
        delete state.statsUpdateRows[payload.rowIndex];
      }
      return {
        ...state,
        statsUpdateRows: {
          ...state.statsUpdateRows,
        },
      };
    }
    default:
      throw new Error('Invalid action type');
  }
};

const FormalGameProvider = ({ children }) => {
  const [state, dispatch] = useReducer(formalGameReducer, initFormalGameState);

  return (
    <FormalGameStateContext.Provider value={state}>
      <FormalGameDispatchContext.Provider value={dispatch}>{children}</FormalGameDispatchContext.Provider>
    </FormalGameStateContext.Provider>
  );
};

const useFormalGameState = () => {
  const context = useContext(FormalGameStateContext);

  if (context === undefined) {
    throw new Error('useFormalGameState must be used within a FormalGameProvider');
  }
  return context;
};

const useFormalGameDispatch = () => {
  const context = useContext(FormalGameDispatchContext);

  if (context === undefined) {
    throw new Error('useFormalGameDispatch must be used within a FormalGameProvider');
  }
  return context;
};

export { FormalGameProvider, useFormalGameState, useFormalGameDispatch };
